module.exports = {
	getAttributes({ commit }) {
		// console.log(payload.params);

		return axios.get(`/api/attributes`).then(({ data }) => {
			commit(
				"SET_VALUE",
				{
					name: "admin.attributes",
					value: data
				},
				{ root: true }
			);

			return data;
		});
	},

	updateAttribute({ commit }, payload) {
		return axios
			.patch(`/api/attributes/${payload.id}`, payload.form)
			.then(({ data }) => {
				let date = Date.now();

				commit("updateAttributeFields", {
					data
				});

				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "Attribute has been saved",
						id: `attribute-${data.id}-saved-${date}`
					},
					{ root: true }
				);

				return data;
			});
	},

	deleteAttribute({ commit }, payload) {
		return Vue.swal({
			title: "Are you sure?",
			text:
				"This cannot be undone. All data between this Attribute and products will be lost.",
			type: "question",
			showCancelButton: true,
			confirmButtonText: "Okay"
		}).then(result => {
			if (result.value) {
				return axios
					.delete(`/api/attributes/${payload}`)
					.then(({ data }) => {
						if (data.success) {
							let date = Date.now();

							commit(
								"REMOVE_ITEM",
								{
									name: "admin.attributes",
									key: "id",
									value: payload
								},
								{ root: true }
							);

							commit(
								"ADD_NOTIFICATION",
								{
									show: true,
									type: "success",
									text: "Document has been deleted",
									id: `document-${payload}-deleted-${date}`
								},
								{ root: true }
							);

							return data;
						}
					});
			}
		});
	},

	getPermissions({ commit }) {
		return axios.get("/api/permissions").then(({ data }) => {
			commit(
				"SET_VALUE",
				{ name: "admin.permissions", value: data },
				{ root: true }
			);

			return data;
		});
	},

	getRolePermissions({ commit, getters }, payload) {
		return axios
			.get(`/api/roles/${payload.id}/permissions`)
			.then(({ data }) => {
				commit(
					"SET_VALUE",
					{
						name: `admin.roles.${_.findIndex(getters.permissions, {
							id: payload.id
						})}.permissions`,
						value: data
					},
					{ root: true }
				);

				return data;
			});
	},

	getRoles({ commit }) {
		return axios.get("/api/roles").then(({ data }) => {
			commit(
				"SET_VALUE",
				{ name: "admin.roles", value: data },
				{ root: true }
			);

			return data;
		});
	},

	postRolePermissions({ commit, state }, payload) {
		return axios
			.post(`/api/roles/${payload.id}/permissions`, {
				permissions: payload.data
			})
			.then(({ data }) => {
				commit("updatePermissions", data);

				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "Permissions have been saved",
						id: `permissions-${payload.id}-save-${Date.now()}`
					},
					{ root: true }
				);

				return data;
			});
	},

	createUser({ commit }, payload) {
		return axios.post("/api/users/", payload).then(({ data }) => {
			commit(
				"PUSH_ITEM",
				{
					name: "admin.users",
					value: data
				},
				{ root: true }
			);

			return data;
		});
	},

	updateUser({ commit, rootGetters }, payload) {
		return axios
			.patch(`/api/users/${payload.id}`, payload.form)
			.then(({ data }) => {
				let date = Date.now();

				commit("updateUserFields", {
					data
				});

				if (rootGetters.user.id === data.id) {
					commit("UPDATE_USER", data, { root: true });
				}

				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "User has been saved",
						id: `user-${data.id}-saved-${date}`
					},
					{ root: true }
				);

				return data;
			});
	},

	sendImport({ commit }, payload) {
		return axios
			.post(payload.url, payload.formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			})
			.then(({ data }) => {
				return data;
			});
	},

	deleteUser({ commit, state, getters }, id) {
		return axios.delete(`/api/user/${id}`).then(({ data }) => {
			if (data.success) {
				commit("deleteUser", id);
			}

			return data;
			// const currentUsers = getObjectValue("admin.users", state, []);

			// const usersMap = {};
			// currentUsers.forEach(user => (usersMap[user.id] = user));
			// usersMap[user.id] = user;
			// users = Object.values(usersMap);

			// commit("SET_VALUE", { name: "admin.users", value: users });

			// return user;
		});
	},

	getPermissionGroups({ commit, dispatch }, payload = {}) {
		let url = `/api/document-center/permissionGroups`;

		return axios.get(url, { params: payload }).then(({ data }) => {
			commit("setPermissionGroups", data);
		});
	}
};
